"use strict";

require('./CompanyCommentsService.js');
require('./CompanyFeedActivity.js');
require('./CompanyFeedActivityDirective.js');
require('../blogs/CompanyMessageService.js');
require('../blogs/CompanyMessageDetailCtrl.js');


CompanyCommentsCtrl.$inject = [
  '$scope',
  'activities'];
function CompanyCommentsCtrl(
  $scope,
  activities) {
  $scope.activities= activities;
}

CompanyCommentsCtrl.resolve = {
  activities: ['$stateParams', 'CompanyFeedActivity', 'info', function($stateParams, CompanyFeedActivity, info) {
    return new CompanyFeedActivity($stateParams.companyId, info.features.blogs);
  }]
};

module.exports = CompanyCommentsCtrl;

angular.module("dokiv")
  .controller("CompanyCommentsCtrl", CompanyCommentsCtrl);



//////////////////
// WEBPACK FOOTER
// ./scripts/company/comments/CompanyCommentsCtrl.js
// module id = 323
// module chunks = 0